import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { activateDeliveryFailure, activateDeliveryStart, activateDeliverySuccess, addDeliveryFailure, addDeliveryStart, addDeliverySuccess, getDeliveriesFailure, getDeliveriesStart, getDeliveriesSuccess, getLivreurSuccess, getTransporteursSuccess, updateDeliveryFailure, updateDeliveryStart, updateDeliverySuccess } from "./DeliveryActions";


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getDeliveries = async(dispatch, pageSize, page, type, agence, username, idWilaya, nom, vehnom, vehmat)=>{
    let deliveryFilter = {type, agence, username, wilaya: idWilaya, nom, vehnom: vehnom, vehmat: vehmat};
    dispatch(getDeliveriesStart());
    try{
        const res = await axiosInstance.post(`/admin/deliveries?pageSize=${pageSize}&page=${page}`,deliveryFilter,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getDeliveriesSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getDeliveriesFailure(err.response.data.message))
        }else{
            dispatch(getDeliveriesFailure("Unkown Error"))
        }
    }
}

export const addDelivery = async(dispatch,type,agence,username,password, idWilaya, idCommune, nom, prenom, email,tel1,tel2, vehnom, vehmat)=>{
    let delivery = {type,agence,username,password, wilaya: idWilaya, commune: idCommune, nom, prenom, email,tel1,tel2,vehnom,vehmat};
    dispatch(addDeliveryStart())
    try{
        const res = await axiosInstance.post(`/admin/deliveries/add`,delivery,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addDeliverySuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(addDeliveryFailure(err.response.data.message))
        }else{
            dispatch(addDeliveryFailure("Unkown Error"))
        }
    }
}

export const updateDelivery = async(dispatch,id, type, agence, username, password, idWilaya, idCommune, nom, prenom, email, tel1, tel2, vehnom, vehmat)=>{
    let delivery = {type,agence,username,password,wilaya:idWilaya,commune:idCommune,nom,prenom,email,tel1,tel2,vehnom,vehmat};
    dispatch(updateDeliveryStart())
    try{
        const res = await axiosInstance.put(`/admin/deliveries/update/${id}`,delivery,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateDeliverySuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(updateDeliveryFailure(err.response.data.message))
        }else{
            dispatch(updateDeliveryFailure("Unkown Error"))
        }
    }
}

export const ToggleActiveDelivery = async(dispatch,deliveryId)=>{
    dispatch(activateDeliveryStart())
    try{
        const res = await axiosInstance.post(`/admin/deliveries/active`,{id: deliveryId},{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(activateDeliverySuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(activateDeliveryFailure(err.response.data.message))
        }else{
            dispatch(activateDeliveryFailure("Unkown Error"))
        }
    }
}

export const getTransporteurs = async(dispatch)=>{
    try{
        const res = await axiosInstance.get(`/admin/deliveries/transporteurs`,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getTransporteursSuccess(res.data));
    }catch(err){
        if(err.response){
            console.log(err.response.data.message);
        }else{
            console.log("Unkown Error");
        }
    }
}

export const getLivreurs = async(dispatch)=>{
    try{
        const res = await axiosInstance.get(`/admin/deliveries/livreurs`,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getLivreurSuccess(res.data));
    }catch(err){
        if(err.response){
            console.log(err.response.data.message);
        }else{
            console.log("Unkown Error");
        }
    }
}